import { useState } from 'react';
import { TYPE_BUTTONS } from '../../../../constans';
import Row from '../../../Basic/Blocks/Row';
import Button from '../../../Basic/Buttons/Button';
import H2 from '../../../Basic/WrapsStyle/H/H2';

import PackageApi from '../../../../API/shipment/package-api';
import PopUp from '../../../Basic/Blocks/PopUp';
import Input from '../../../Basic/Inputs/Base';
import styles from './styles.module.scss';

const PackageMethodPopUp = ({ close = () => { } }) => {
  const [data, setData] = useState({
    method: '',
    pay: 0,
  });

  const clickAdd = () => {
    PackageApi.add({ data: { method: data.method, pay: parseInt(data.pay) } })
      .then((res) => {
        close();
      })
      .catch((err) => console.log(err));
  };

  return (
    <PopUp close={close} clickOutside={false} className={styles.pop_up}>
      <H2>Добавить новый способ</H2>

      <Input value={data.method} label="Способ упаковки" onChange={(v) => setData({ ...data, method: v })} />
      <Input value={data.pay} label="Ставка" onChange={(v) => setData({ ...data, pay: parseInt(v) })} />

      <Row style={{ marginTop: '30px' }}>
        <Button
          type={TYPE_BUTTONS.BLUE}
          style={{ marginRight: '20px' }}
          disabled={data.method.length < 0}
          onClick={clickAdd}
        >
          Добавить
        </Button>
        <Button type={TYPE_BUTTONS.GREY} onClick={close}>
          Отменить
        </Button>
      </Row>
    </PopUp>
  );
};

export default PackageMethodPopUp;
